import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetcher, throwApiError } from '@commenda/utils';

import { adminManagedAgentsKeys } from './keys';
import type { IActivateManagedAgentParams } from './types';

export function useActivateAdminManagedAgent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      params,
    }: {
      id: string;
      params: IActivateManagedAgentParams;
    }) => {
      const response = await fetcher(`admin/managed-agents/${id}/activate`, {
        method: 'POST',
        body: params,
      });
      if (!response.ok)
        await throwApiError(response, 'Failed to activate the agent');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminManagedAgentsKeys.all });
    },
  });
}
